import {useEffect} from 'react'

import {connect} from '../../state/hooks/tools'
import {createResource} from '../../lib/asyncMethods'
import {getToken, setSessionTokens} from '../../lib/auth'
import {SESSION} from '../../state/actionTypes'

const SessionController = props => {
  useEffect(() => {
    const interval = setInterval(() => {
      const authToken = getToken('authToken')
      const refreshToken = getToken('refreshToken')

      if (authToken && refreshToken) {
        props.createResource({endpoint: 'auth/introspect', attributes: {token: authToken}}).then(response => {
          if (!response.success)
            return

          const {active, exp} = response.data
          const timeLeft = Math.floor(exp - (Date.now() / 1000)) // in seconds

          // an inactive token reports no expiry to compare against and is already due for replacement
          if (!active || timeLeft <= 600) {
            // passing the token being replaced retires its session as part of the refresh
            props.createResource({endpoint: 'auth/refresh', attributes: {refreshToken, authToken}}).then(response => {
              if (response.success)
                setSessionTokens(response.data)
            })
          }
        })
      }
    }, 420000) // every 7mins

    return () => {
      clearInterval(interval)
    }
  }, [])

  return props.children
}

const actionCreators = ({auth}) => ({
  createResource: createResource(auth, SESSION)
})

export default connect(null, actionCreators)(SessionController)
